<script>
  // Importa el componente Cliente
  import DashboardView from "../../viewsERP/Dashboard.svelte";
  
  export let location;
</script>

<div class="flex flex-wrap mt-4">
<div class="w-full mb-12 px-4">
  <DashboardView />
</div>
</div>
